<template>

    <div class="skill_score_radio">

        <div class="slider_label">
            {{ currentLabel }}
        </div>

        <div class="skill_score_radios_container">

            <SkillScoreRadioWrapper :value="val" score-number="1" :second-check="friendRef1Score == 1" :third-check="friendRef2Score == 1" :is-ref-model="refScore == 1" :isMoyScore="moyScore == 1">
                <input type="radio" :value="1" v-model="val" :disabled="disabled" >
            </SkillScoreRadioWrapper>
            <SkillScoreRadioWrapper :value="val" score-number="2" :second-check="friendRef1Score == 2" :third-check="friendRef2Score == 2" :is-ref-model="refScore == 2" :isMoyScore="moyScore == 2">
                <input type="radio" :value="2" v-model="val" :disabled="disabled" >
            </SkillScoreRadioWrapper>
            <SkillScoreRadioWrapper :value="val" score-number="3" :second-check="friendRef1Score == 3" :third-check="friendRef2Score == 3" :is-ref-model="refScore == 3" :isMoyScore="moyScore == 3">
                <input type="radio" :value="3" v-model="val" :disabled="disabled" >
            </SkillScoreRadioWrapper>
            <SkillScoreRadioWrapper :value="val" score-number="4" :second-check="friendRef1Score == 4" :third-check="friendRef2Score == 4" :is-ref-model="refScore == 4" :isMoyScore="moyScore == 4">
                <input type="radio" :value="4" v-model="val" :disabled="disabled" >
            </SkillScoreRadioWrapper>
            <SkillScoreRadioWrapper :value="val" score-number="5" :second-check="friendRef1Score == 5" :third-check="friendRef2Score == 5" :is-ref-model="refScore == 5" :isMoyScore="moyScore == 5">
                <input type="radio" :value="5" v-model="val" :disabled="disabled" >
            </SkillScoreRadioWrapper>

        </div>


    </div>

</template>

<script>
import s3SkillsLabels from '@/locales/s3SkillsLabels'

export default {
    name: 'SkillScoreRadios',
    props: [ 'score', 'refScore', 'scoreId', 'label', 'friendRef1', 'friendRef2', 'disabled', 'moyScore' ],
    data(){
        return {
            labels: s3SkillsLabels
        }
    },
    computed: {
        currentLabel(){
            return this.label ? this.label : this.labels[this.$i18n.locale][this.scoreId]
        },
        val: {
            get(){
                return this.score
            },
            set(newScore){
                if(!this.disabled){
                    this.$emit('change', {val: newScore, id: this.scoreId} )
                }
            }
        },
        friendRef1Score(){
            if(this.friendRef1){
                return this.friendRef1.sight3_scores[this.scoreId]
            }else{
                return false
            }
        },
        friendRef2Score(){
            if(this.friendRef2){
                return this.friendRef2.sight3_scores[this.scoreId]
            }else{
                return false
            }
        }
    }
}

</script>

<style lang="scss" scoped>
.skill_score_radio{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 12px 0;
    user-select:none;

    .slider_label{
        min-width: 300px;
        max-width: 300px;
        text-align: left;
        margin-bottom: 12px;
        // text-transform: uppercase;
        // font-weight: 600;
        color: $grey-light;
    }
    .skill_score_radios_container{
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>